import {
    REQUERT_MAIN_PLANTEMPLATE_FAILED, GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED
    , REQUERT_KHName_PLANTEMPLATE_FAILED, GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED
    , REQUERT_Delete_PLANTEMPLATE_FAILED, GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED
} from '../actions/actionTypes'
import {combineReducers} from 'redux'

const mainReducer = (DataMain = [], actions) => {
    switch (actions.type) {
        case GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED:
            if (Object.keys(actions.DataMain).length > 0) {
                return { ...DataMain, DataMain: actions.DataMain };
            }
            else {
                return { ...DataMain, DataMain: [] };
            }
        case REQUERT_MAIN_PLANTEMPLATE_FAILED:
            return { ...DataMain, DataMain: [] };
        default:
            return DataMain;
    }
}
const KHNameReducer = (DataKHName = [], actions) => {
    switch (actions.type) { 
        case GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED:
            if (Object.keys(actions.DataKHName).length > 0) {
                return { ...DataKHName, DataKHName: actions.DataKHName };
            }
            else {
                return { ...DataKHName, DataKHName: [] };
            }
        case REQUERT_KHName_PLANTEMPLATE_FAILED:
            return { ...DataKHName, DataKHName: [] };

        default:
            return DataKHName;
    }
}
const DeleteReducer = (DataDelete = [], actions) => {
    switch (actions.type) { 
        case GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED:
            if (Object.keys(actions.DataDelete).length > 0) {
                return { ...DataDelete, DataDelete: actions.DataDelete };
            }
            else {
                return { ...DataDelete, DataDelete: [] };
            }
        case REQUERT_Delete_PLANTEMPLATE_FAILED:
            return { ...DataDelete, DataDelete: [] };

        default:
            return DataDelete;
    }
}

const mainALLReducer = combineReducers({
    mainReducer,KHNameReducer,DeleteReducer
})
export default mainALLReducer;